<div class="plan-access-modal">
  <header class="plan-access-modal__header">
    <h5 class="tw-m-0 smsir-h5-lg tw-text-[rgb(var(--text-accent-primary))]">
      برای دسترسی بیشتر، حساب خود را ارتقاء بدهید
    </h5>
    <p class="tw-m-0 tw-mt-2 smsir-helper-lg tw-text-[rgb(var(--text-secondary))] tw-text-center">
      به نظر می‌رسد آماده‌اید تا از پنل خود استفاده بیشتری کنید. با ارتقاء حساب خود می‌توانید از سایر امکانات پیشرفته پنل بهره ببرید.
    </p>
  </header>

  <ng-container *ngIf="planPackages$ | async as packages; else loadingTemplate">
    <div class="plan-access-modal__grid">
      <article
        *ngFor="let package of packages; let i = index"
        class="plan-access-card"
        [class.plan-access-card--featured]="isFeatured(i)"
        [attr.data-tier]="cardMeta(i).tier"
      >
        <div class="plan-access-card__inner">
          <div class="plan-access-card__hero">
            <i
              class="plan-access-card__icon"
              [ngClass]="cardMeta(i).iconClass"
              aria-hidden="true"
            ></i>

            <div class="plan-access-card__heading">
              <h3 class="plan-access-card__title smsir-h6-lg">{{ package.plan.name }}</h3>
              <smsir-label
                *ngIf="isFeatured(i)"
                size="sm"
                variant="accent"
                value="پیشنهاد کاربران"
              ></smsir-label>
            </div>

            <p dir="ltr" class="plan-access-card__price smsir-h5-lg">
              {{ package.cost | rial | commaSeparator }}
              <span class="plan-access-card__currency smsir-helper-md">تومان</span>
            </p>
          </div>

          <div class="plan-access-card__body">
            <div class="plan-access-card__row">
              <span class="smsir-helper-md tw-text-[rgb(var(--text-secondary))]">قیمت هر پیامک</span>
              <span dir="ltr" class="smsir-helper-lg tw-text-[rgb(var(--text-primary))]">
                از {{ package.plan.basePriceRange[1] | rial }} تا {{ package.plan.basePriceRange[0] | rial }} تومان
              </span>
            </div>
            <smsir-divider class="!tw-my-0"></smsir-divider>

            <div class="plan-access-card__row">
              <span class="smsir-helper-md tw-text-[rgb(var(--text-secondary))]">شارژ هدیه</span>
              <span class="smsir-helper-lg tw-text-[rgb(var(--text-primary))]">
                {{ package.credit ? ((package.credit.creditCount | commaSeparator) + ' پیامک') : 'ندارد' }}
              </span>
            </div>
            <smsir-divider class="!tw-my-0"></smsir-divider>

            <div class="plan-access-card__row">
              <span class="smsir-helper-md tw-text-[rgb(var(--text-secondary))]">شماره اختصاصی</span>
              <span class="smsir-helper-lg tw-text-[rgb(var(--text-primary))]">
                {{ _PlanUtilsService.formatLineDisplay(package) }}
              </span>
            </div>

            <button
              type="button"
              smsir-button
              variant="tertiary"
              size="sm"
              class="tw-mt-auto tw-w-full"
              (click)="submit()"
            >
              انتخاب
            </button>
          </div>
        </div>
      </article>
    </div>

    <div class="plan-access-modal__actions">
      <button type="button" smsir-button variant="ghost" size="sm" class="plan-access-modal__action-btn" (click)="onCancel()">
        بعدا انجام می‌دهم!
      </button>
      <button type="button" smsir-button variant="secondary" size="sm" class="plan-access-modal__action-btn" (click)="submit()">
        مشاهده پلن‌ها
      </button>
    </div>
  </ng-container>
</div>

<ng-template #loadingTemplate>
  <div class="plan-access-modal" role="status" aria-busy="true" aria-label="در حال بارگذاری پلن ها">
    <header class="plan-access-modal__header tw-flex tw-flex-col tw-items-center tw-gap-2">
      <smsir-skeleton class="tw-h-6 tw-w-72 tw-rounded"></smsir-skeleton>
      <smsir-skeleton class="tw-h-4 tw-w-full tw-max-w-md tw-rounded"></smsir-skeleton>
      <smsir-skeleton class="tw-h-4 tw-w-3/4 tw-max-w-sm tw-rounded"></smsir-skeleton>
    </header>

    <div class="plan-access-modal__grid">
      <div
        *ngFor="let item of skeletonCards"
        class="tw-flex tw-flex-col tw-gap-3 tw-rounded-3xl tw-bg-[rgb(var(--bg-detail-container))] tw-p-4"
      >
        <smsir-skeleton class="tw-h-7 tw-w-7 tw-rounded-full"></smsir-skeleton>
        <smsir-skeleton class="tw-h-5 tw-w-20 tw-rounded"></smsir-skeleton>
        <smsir-skeleton class="tw-h-7 tw-w-28 tw-rounded"></smsir-skeleton>
        <smsir-skeleton class="tw-mt-2 tw-h-4 tw-w-full tw-rounded"></smsir-skeleton>
        <smsir-skeleton class="tw-h-4 tw-w-full tw-rounded"></smsir-skeleton>
        <smsir-skeleton class="tw-h-4 tw-w-full tw-rounded"></smsir-skeleton>
        <smsir-skeleton class="tw-mt-2 tw-h-10 tw-w-full tw-rounded-xl"></smsir-skeleton>
      </div>
    </div>
  </div>
</ng-template>
